// extracted by mini-css-extract-plugin
export default {"container":"LrcJkm","detailsContainer":"HVv85x","entityTableContainer":"XhHKjn","flexedContainer":"foyb_n","statusContainer":"kqUO14"};